<script lang="ts" setup>
const { isAlertShowing, alertMessage, closeAlert } = useAlert()

const runtimeConfig = useRuntimeConfig()

// TODO: remove this
if (runtimeConfig.public.environment === 'production') {
  useHead({
    script: [
      {
        children: `window.fbAsyncInit=function(){FB.init({appId:"586684370267023",autoLogAppEvents:!0,xfbml:!0,version:"v17.0"})};`,
      },
      {
        async: true,
        defer: true,
        crossorigin: 'anonymous',
        src: 'https://connect.facebook.net/en_US/sdk.js',
      },
    ],
  })
}
else {
  useHead({
    meta: [
      {
        name: 'robots',
        content: 'noindex, nofollow',
      },
    ],
  })
}
</script>

<template>
  <div>
    <NuxtLoadingIndicator />
    <AppNotification
      :show="isAlertShowing"
      :message-type="alertMessage.type"
      :message-title="alertMessage.title"
      :message="alertMessage.message"
      @close="closeAlert"
    />
    <NuxtPage />
  </div>
</template>
